const RAW_BASE_URL = process.env.REACT_APP_BASE_URL || "https://cdn24.wsiz.edu.pl/api";

export interface BlogPost {
  id: number;
  title_pl: string;
  desc_pl: string;
  title_eng: string;
  desc_eng: string;
  author: string;
  is_public: boolean;
  created_at: string;
}

export async function fetchPublicPosts(page = 1, pageSize = 3): Promise<BlogPost[]> {
  const url = `${RAW_BASE_URL}/v2/main_page/posts/public?page=${page}&page_size=${pageSize}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  });

  if (!res.ok) {
    throw new Error(`Posts API error: ${res.status} ${res.statusText}`);
  }

  const data = await res.json();
  
  return data.posts ?? [];
}